module.exports = __webpack_public_path__ + "media/images/icons/twitter-29b0b952a44b699c8bb1e4f7e1be775a.svg";